import { defineComponent as T, toRefs as $, ref as y, onMounted as k, onBeforeUnmount as b, watch as R, nextTick as B } from "vue";
const W = /* @__PURE__ */ T({
  __name: "masonry-wall",
  props: {
    columnWidth: { default: 400 },
    items: null,
    gap: { default: 0 },
    rtl: { type: Boolean, default: !1 },
    ssrColumns: { default: 0 },
    scrollContainer: { default: null }
  },
  emits: ["redraw", "redraw-skip"],
  setup(s, { emit: e }) {
    const f = s, { columnWidth: r, items: a, gap: u, rtl: i, ssrColumns: m, scrollContainer: n } = $(f), t = y([]), _ = y();
    function h() {
      const l = Math.floor(
        (_.value.getBoundingClientRect().width + u.value) / (r.value + u.value)
      );
      return l > 0 ? l : 1;
    }
    function o(l) {
      return [...new Array(l)].map(() => []);
    }
    if (m.value > 0) {
      const l = o(m.value);
      a.value.forEach(
        (c, v) => l[v % m.value].push(v)
      ), t.value = l;
    }
    async function w(l) {
      if (l >= a.value.length)
        return;
      await B();
      const c = [..._.value.children];
      i.value && c.reverse();
      const v = c.reduce(
        (g, C) => C.getBoundingClientRect().height < g.getBoundingClientRect().height ? C : g
      );
      t.value[+v.dataset.index].push(l), await w(l + 1);
    }
    async function d(l = !1) {
      if (t.value.length === h() && !l) {
        e("redraw-skip");
        return;
      }
      t.value = o(h());
      const c = n == null ? void 0 : n.value, v = c ? c.scrollTop : window.scrollY;
      await w(0), c ? c.scrollBy({ top: v - c.scrollTop }) : window.scrollTo({ top: v }), e("redraw");
    }
    const p = typeof ResizeObserver > "u" ? void 0 : new ResizeObserver(() => d());
    return k(() => {
      d(), p == null || p.observe(_.value);
    }), b(() => p == null ? void 0 : p.unobserve(_.value)), R([a, i], () => d(!0)), R([r, u], () => d()), { __sfc: !0, props: f, emit: e, columnWidth: r, items: a, gap: u, rtl: i, ssrColumns: m, scrollContainer: n, columns: t, wall: _, columnCount: h, createColumns: o, fillColumns: w, redraw: d, resizeObserver: p };
  }
});
function M(s, e, f, r, a, u, i, m) {
  var n = typeof s == "function" ? s.options : s;
  e && (n.render = e, n.staticRenderFns = f, n._compiled = !0), r && (n.functional = !0), u && (n._scopeId = "data-v-" + u);
  var t;
  if (i ? (t = function(o) {
    o = o || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !o && typeof __VUE_SSR_CONTEXT__ < "u" && (o = __VUE_SSR_CONTEXT__), a && a.call(this, o), o && o._registeredComponents && o._registeredComponents.add(i);
  }, n._ssrRegister = t) : a && (t = m ? function() {
    a.call(
      this,
      (n.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : a), t)
    if (n.functional) {
      n._injectStyles = t;
      var _ = n.render;
      n.render = function(w, d) {
        return t.call(d), _(w, d);
      };
    } else {
      var h = n.beforeCreate;
      n.beforeCreate = h ? [].concat(h, t) : [t];
    }
  return {
    exports: s,
    options: n
  };
}
var x = function() {
  var e = this, f = e._self._c, r = e._self._setupProxy;
  return f("div", { ref: "wall", staticClass: "masonry-wall", style: { display: "flex", gap: `${r.gap}px` } }, e._l(r.columns, function(a, u) {
    return f("div", { key: u, staticClass: "masonry-column", style: {
      display: "flex",
      "flex-basis": "0px",
      "flex-direction": "column",
      "flex-grow": 1,
      gap: `${r.gap}px`,
      height: ["-webkit-max-content", "-moz-max-content", "max-content"],
      "min-width": 0
    }, attrs: { "data-index": u } }, e._l(a, function(i) {
      return f("div", { key: i, staticClass: "masonry-item" }, [e._t("default", function() {
        return [e._v(" " + e._s(r.items[i]) + " ")];
      }, { item: r.items[i], index: i })], 2);
    }), 0);
  }), 0);
}, U = [], E = /* @__PURE__ */ M(
  W,
  x,
  U,
  !1,
  null,
  null,
  null,
  null
);
const F = E.exports, S = /* @__PURE__ */ (() => {
  const s = F;
  return s.install = (e) => {
    e.component("MasonryWall", s);
  }, s;
})();
export {
  S as default
};
